import { Component, OnInit } from '@angular/core';
import { interval } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../core/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {

  year: number = new Date().getFullYear();
  currentSection: any = 'home';

  // Timeline config
  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: true
  };
  // Team config
  config = {
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false
  };
  // About config
  aboutConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false
  };

  private _trialEndsAt;

  private _diff!: number;
  _days!: number;
  _hours!: number;
  _minutes!: number;
  _seconds!: number;

  constructor(private authService: AuthenticationService, private router: Router) { }

  ngOnInit() {
    this._trialEndsAt = "2023-12-31";

    // Countdown logic
    interval(3000).pipe(
      map((x) => {
        this._diff = Date.parse(this._trialEndsAt) - Date.parse(new Date().toString());
      })).subscribe((x) => {
        this._days = this.getDays(this._diff);
        this._hours = this.getHours(this._diff);
        this._minutes = this.getMinutes(this._diff);
        this._seconds = this.getSeconds(this._diff);
      });

    // Wait for Facebook SDK to load
    this.loadFacebookSDK().then(() => {
      console.log("Facebook SDK loaded, now you can use window['FB']");
      window['FB'].getLoginStatus((response: any) => {
        console.log("Login Status:", response);
      });
    }).catch(err => {
      console.error("Error loading Facebook SDK:", err);
    });
  }

  // Facebook login initiation
  initiateEmbeddedSignup() {
    window['FB'].login((response: any) => {
      if (response.authResponse) {
        console.log('User logged in:', response);
      } else {
        console.log('User login failed');
      }
    }, { scope: 'public_profile,email' });
  }

  // Utility function to check when Facebook SDK is ready
  loadFacebookSDK(): Promise<void> {
    return new Promise((resolve, reject) => {
      const checkFB = () => {
        if (window['FB']) {
          resolve();
        } else {
          setTimeout(checkFB, 100);
        }
      };
      checkFB();
    });
  }

  getDays(t) {
    return Math.floor(t / (1000 * 60 * 60 * 24));
  }

  getHours(t) {
    return Math.floor((t / (1000 * 60 * 60)) % 24);
  }

  getMinutes(t) {
    return Math.floor((t / 1000 / 60) % 60);
  }

  getSeconds(t) {
    return Math.floor((t / 1000) % 60);
  }

  // Scroll method for sticky navbar
  windowScroll() {
    const navbar = document.getElementById('navbar');
    if (document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50) {
      navbar.classList.add('nav-sticky');
    } else {
      navbar.classList.remove('nav-sticky');
    }
  }

  // Toggle menu
  toggleMenu() {
    document.getElementById('topnav-menu-content').classList.toggle('show');
  }

  // Section change
  onSectionChange(sectionId: string) {
    this.currentSection = sectionId;
  }

  // Check if the user is logged in
  isLoggedIn(): boolean {
    return localStorage.getItem('currentUser') !== null;
  }

  // Logout
  logout() {
    this.authService.logout();
    this.router.navigate(['/home']);
  }
}
